import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import DaysLeft from '~src/shared/daysLeft/DaysLeft';

import PopoverInfo from './PopoverInfo';
import { NavigationContainer, QuestionsAmount, TimeLeft } from './shared.sc';
import { InfoContainer, Spacing } from './questionsInfo.sc';

interface Props {
  count: number;
  surveyName: string;
  isAnonymous?: boolean;
  dueDate?: string | null;
  selection?: string | null;
  isSelfAssessment?: boolean;
}

const QuestionsInfo: FC<Props> = (props) => {
  const { dueDate = null, count, surveyName, isAnonymous = false, selection = null, isSelfAssessment = false } = props;
  const { t } = useTranslation();
  return (
    <NavigationContainer>
      <InfoContainer>
        {dueDate && (
          <>
            <TimeLeft>
              <DaysLeft t={t} withDot date={dueDate} />
            </TimeLeft>
            <Spacing>-</Spacing>
          </>
        )}
        <QuestionsAmount>{surveyName}</QuestionsAmount>
        <Spacing>-</Spacing>
        <QuestionsAmount>{`${t('x.questionstream.navbar.questions_new', { count })}`}</QuestionsAmount>
        <Spacing>|</Spacing>
        <PopoverInfo
          selection={selection}
          isAnonymous={isAnonymous}
          isSelfAssessment={isSelfAssessment}
          t={t}
        />
      </InfoContainer>
    </NavigationContainer>
  );
};

export default QuestionsInfo;
